import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * Pillタブ
 *【pillタブリスト:items:{label:string, value:string, disabled?:boolean}[]】
 *【タイプ:pillType:string】
 *【2ndデザイン:secondary:boolean】
 *【選択項目:checked:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-pill',
  templateUrl: './pill.html',
  styles: [`
    
  `]
})
export class Pill extends BaseWidget {
  /**
   * 選択項目の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択項目に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * pillタブリスト
   */
  @Input() items:{label:string, value:string, disabled?:boolean}[]

  /**
   * タイプ
   */
  @Input() pillType:string

  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * 選択項目
   */
  @Input() checked:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * 選択中タブ状態を更新する
   * @param {Event} event
   * @param {number} index
   *
   */
  updateChecked(event:Event, index:number):string {
    const value = this.items[index].value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
    return value
  }
  /**
   * デザイン状態を取得する
   *
   */
  get isSecondary() {
    if (!!this.secondary) {
      return true
    } else {
      return
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/tab/pill/pill.component.ts